import { axiosFn, handleError } from "../index";
import * as URL from "../URLs";
import Cookies from "js-cookie";

export async function login(user_type, data) {
  return await axiosFn("post", URL.auth + user_type + URL.login, data)
    .then((res) => {
      return {
        res: res.data,
        err: null,
      };
    })
    .catch(handleError);
}

export async function checkToken(user_type, data) {
  return await axiosFn("patch", "/auth/verify_token_authenticity")
    .then((res) => {
      return {
        res: {message: "success"},
        err: null,
      };
    })
    .catch(() => {
      localStorage.clear();
      Cookies.remove("firebase_auth_token");
      window.location.reload();
    });
}

export async function ShowUser(user_id) {
  return await axiosFn("get", URL.Decendent + user_id)
    .then((res) => {
      return {
        res: res.data,
        err: null,
      };
    })
    .catch(handleError);
}
